/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  SkillEfficacyInsightsResult,
  SkillEfficacyInsightsResult$inboundSchema,
} from "../components/skillefficacyinsightsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type QuerySkillEfficacyInsightsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type QuerySkillEfficacyInsightsRequest = {
  /**
   * Active skill IDs to query (up to 200). Omit to query all active project skills.
   */
  skillIds?: Array<string> | undefined;
  /**
   * RFC3339 window start; defaults to 30 days before to.
   */
  from?: Date | undefined;
  /**
   * RFC3339 window end; defaults to now.
   */
  to?: Date | undefined;
  /**
   * Include per-version daily trends.
   */
  includeVersions?: boolean | undefined;
  /**
   * Include a newest-first page of scored sessions. Intended for one skill detail view.
   */
  includeScoredSessions?: boolean | undefined;
  /**
   * Calculate attributed session cost. Disable for surfaces that do not display it.
   */
  includeSessionCost?: boolean | undefined;
  /**
   * Calculate the current-versus-predecessor efficacy regression signal.
   */
  includeRegressionSignal?: boolean | undefined;
  /**
   * Cursor for the next page of scored sessions.
   */
  cursor?: string | undefined;
  /**
   * The number of scored sessions to return per page.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type QuerySkillEfficacyInsightsResponse = {
  result: SkillEfficacyInsightsResult;
};

/** @internal */
export type QuerySkillEfficacyInsightsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const QuerySkillEfficacyInsightsSecurity$outboundSchema: z.ZodMiniType<
  QuerySkillEfficacyInsightsSecurity$Outbound,
  QuerySkillEfficacyInsightsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function querySkillEfficacyInsightsSecurityToJSON(
  querySkillEfficacyInsightsSecurity: QuerySkillEfficacyInsightsSecurity,
): string {
  return JSON.stringify(
    QuerySkillEfficacyInsightsSecurity$outboundSchema.parse(
      querySkillEfficacyInsightsSecurity,
    ),
  );
}

/** @internal */
export type QuerySkillEfficacyInsightsRequest$Outbound = {
  skill_ids?: Array<string> | undefined;
  from?: string | undefined;
  to?: string | undefined;
  include_versions?: boolean | undefined;
  include_scored_sessions?: boolean | undefined;
  include_session_cost?: boolean | undefined;
  include_regression_signal?: boolean | undefined;
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const QuerySkillEfficacyInsightsRequest$outboundSchema: z.ZodMiniType<
  QuerySkillEfficacyInsightsRequest$Outbound,
  QuerySkillEfficacyInsightsRequest
> = z.pipe(
  z.object({
    skillIds: z.optional(z.array(z.string())),
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    includeVersions: z.optional(z.boolean()),
    includeScoredSessions: z.optional(z.boolean()),
    includeSessionCost: z.optional(z.boolean()),
    includeRegressionSignal: z.optional(z.boolean()),
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 20),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      skillIds: "skill_ids",
      includeVersions: "include_versions",
      includeScoredSessions: "include_scored_sessions",
      includeSessionCost: "include_session_cost",
      includeRegressionSignal: "include_regression_signal",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function querySkillEfficacyInsightsRequestToJSON(
  querySkillEfficacyInsightsRequest: QuerySkillEfficacyInsightsRequest,
): string {
  return JSON.stringify(
    QuerySkillEfficacyInsightsRequest$outboundSchema.parse(
      querySkillEfficacyInsightsRequest,
    ),
  );
}

/** @internal */
export const QuerySkillEfficacyInsightsResponse$inboundSchema: z.ZodMiniType<
  QuerySkillEfficacyInsightsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: SkillEfficacyInsightsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function querySkillEfficacyInsightsResponseFromJSON(
  jsonString: string,
): SafeParseResult<QuerySkillEfficacyInsightsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      QuerySkillEfficacyInsightsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'QuerySkillEfficacyInsightsResponse' from JSON`,
  );
}
